import React from 'react';

export const PageHeader = ({ title, description, actions, children, testId = 'page-header' }) => (
  <div data-testid={testId} className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between animate-fade-in">
    <div className="min-w-0">
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-foreground leading-snug">{title}</h1>
      {description && <p className="mt-1 text-sm sm:text-base text-muted-foreground">{description}</p>}
      {children}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2 md:justify-end">{actions}</div>}
  </div>
);
